import { ArcElement, BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from 'chart.js';
import ChartDataLabels, { Context } from 'chartjs-plugin-datalabels';
import { InsideTextPlugin } from "components/ChartJsPlugins/insideTextPlugin";
import { Bar } from "react-chartjs-2";
import { DashBarDataset, DashValueMode } from 'views/dashboard/components/Charts';

// export const Range0To100 = [
//     { label: t("Monitoring.Statistics.Charts.NotStarted"), backgroundColor: '#dadada' },
//     { label: '0-24%', backgroundColor: "rgba(25, 118, 210, 0.15)" },
//     { label: '25-49%', backgroundColor: "rgba(25, 118, 210, 0.3)" },
//     { label: '50-74%', backgroundColor: "rgba(25, 118, 210, 0.6)" },
//     { label: '75-99%', backgroundColor: "#1976d2" },
//     { label: '100%', backgroundColor: '#20d37d' },
// ];

ChartJS.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    InsideTextPlugin,
    ChartDataLabels,
);

export type DashStackHbarDataset = DashBarDataset[];

export interface IProps {
    height?: number | string;
    width?: number | string;
    datasets: DashStackHbarDataset;
    valueMode: DashValueMode;
    onFormatter?: (value: any, context: Context) => any | null;
    onDataClick?: (id: number, title?: string) => void;
}

export const DashStackHBar = ({ datasets, onDataClick, onFormatter, valueMode, height = 100, width = "100%", }: IProps) => {
    let total = 0;
    datasets.forEach((ds) => { total += ds.data[0]; });

    var chartDs = datasets.map((ds) => ({ ...ds, data: [100.0 * ds.data[0] / total] }));

    return (
        <div id="componentChartCanvas" style={{ position: "relative", height: height, width: width }}>
            <Bar
                data={
                    {
                        labels: [""],
                        datasets: chartDs
                    }
                }
                options={
                    {
                        indexAxis: "y",
                        responsive: true,
                        maintainAspectRatio: false,
                        onClick: (e, elements) => {
                            if (elements.length > 0 && onDataClick) {
                                const datasetIndex = elements[0].datasetIndex;
                                onDataClick(datasets[datasetIndex].id, datasets[datasetIndex].label);
                            }
                        },
                        plugins: {
                            legend: {
                                display: true,
                                position: "bottom",
                                onClick: () => { }
                            },
                            tooltip: {
                                enabled: true,
                                callbacks: {
                                    label: function (context) {
                                        const datasetLabel = context.dataset.label || '';
                                        return datasetLabel
                                            + ": "
                                            + (valueMode == "absolute"
                                                ? datasets[context.datasetIndex].data[0].toString()
                                                : chartDs[context.datasetIndex].data[0].toFixed(1) + "%");
                                    },
                                    title: function (tooltipItems) {
                                        // Customize the title based on the first item's label
                                        return tooltipItems[0].label;
                                    }
                                }
                            },
                            datalabels: {
                                color: '#FFf',
                                anchor: "center",
                                align: "center",
                                clip: false,
                                clamp: true,
                                display: false,
                                formatter: onFormatter
                                    ? onFormatter
                                    : (v, context) => {
                                        return valueMode == "absolute"
                                            ? datasets[context.datasetIndex].data[0]
                                            : chartDs[context.datasetIndex].data[0].toFixed(1) + "%";
                                    }
                            }
                        },
                        scales: {
                            x: {
                                display: true,
                                stacked: true,
                                title: {
                                    display: false,
                                },
                                min: 0,
                                max: 100,
                                grid: {
                                    display: false
                                },
                                ticks: {
                                    display: false
                                },
                                border: { display: false }
                            },
                            y: {
                                display: false,
                                stacked: true,
                                title: {
                                    display: false,
                                }
                            }
                        }
                    }
                }
            />
        </div>
    );
};
